.wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-1);
    width: 100%;
    font-family: var(--tempest-font-sans);
    position: relative;
}

.label {
    font-size: var(--tempest-text-sm);
    font-weight: var(--tempest-weight-semibold);
    color: var(--tempest-text);
    line-height: var(--tempest-leading-snug);
}

.field {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--tempest-space-1);
    min-height: var(--tempest-control-height-md);
    padding: 4px var(--tempest-space-2);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-control-radius);
    background-color: var(--tempest-bg);
    box-shadow: var(--tempest-shadow-xs);
    cursor: text;
    transition: var(--tempest-transition-color), var(--tempest-transition-shadow);
}

.field:focus-within {
    border-color: var(--tempest-primary);
    box-shadow: 0 0 0 var(--tempest-focus-ring-width) var(--tempest-focus-ring-color);
}

.field.disabled {
    background-color: var(--tempest-surface);
    cursor: not-allowed;
}

.chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 4px 2px 8px;
    border-radius: var(--tempest-radius-full);
    background-color: var(--tempest-primary-soft);
    color: var(--tempest-primary-on-soft);
    font-size: var(--tempest-text-xs);
    font-weight: var(--tempest-weight-medium);
    line-height: 1.4;
}

.chipRemove {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border: none;
    border-radius: 50%;
    background: transparent;
    color: inherit;
    font-size: 14px;
    line-height: 1;
    cursor: pointer;
}

.chipRemove:hover {
    background-color: var(--tempest-primary);
    color: var(--tempest-primary-foreground);
}

.input {
    flex: 1;
    min-width: 80px;
    border: none;
    outline: none;
    background: transparent;
    color: var(--tempest-text);
    font-family: inherit;
    font-size: var(--tempest-control-font-md);
    height: 24px;
}

.input::placeholder {
    color: var(--tempest-text-subtle);
}

.menu {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: var(--tempest-z-dropdown);
    background-color: var(--tempest-bg);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-radius-lg);
    box-shadow: var(--tempest-shadow-lg);
    max-height: 280px;
    overflow-y: auto;
    padding: var(--tempest-space-1);
    list-style: none;
    margin: 0;
}

.option {
    display: flex;
    align-items: center;
    gap: var(--tempest-space-2);
    padding: var(--tempest-space-2) var(--tempest-space-3);
    border-radius: var(--tempest-radius-sm);
    cursor: pointer;
    color: var(--tempest-text);
    font-size: var(--tempest-text-base);
    line-height: var(--tempest-leading-snug);
}

.check {
    display: inline-flex;
    width: 16px;
    justify-content: center;
    color: var(--tempest-primary);
    font-weight: var(--tempest-weight-bold);
}

@media (hover: hover) and (pointer: fine) {
    .option:hover {
        background-color: var(--tempest-surface);
    }
}

.option.active {
    background-color: var(--tempest-primary-soft);
    color: var(--tempest-primary-on-soft);
}

.option.selected {
    font-weight: var(--tempest-weight-semibold);
}

.empty {
    padding: var(--tempest-space-3);
    color: var(--tempest-text-muted);
    font-size: var(--tempest-text-sm);
    text-align: center;
}

.helper {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-text-muted);
}

.errorText {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-danger);
}

.wrapper.error .field {
    border-color: var(--tempest-danger);
}
